<template>
  <div class="box">
    <div class="addWork">
    <van-form @submit="onSubmit">
        <van-cell-group>
          <!-- <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.empno" placeholder="请输入工号" label="工号"/> -->
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" @change="setStateTime" type="date" v-model="baseinfo.begindate" label="开始时间"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" @change="setEndTime" type="date" v-model="baseinfo.enddate" label="结束时间"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.workcity" placeholder="请输入工作城市" label="工作城市"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.organization" placeholder="请输入公司名称" label="公司名称"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.position" placeholder="请输入岗位名称" label="岗位名称"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.duty" placeholder="请输入主要职责" label="主要职责"/>
        </van-cell-group>
        <div class="btnBox">
            <van-button round block type="info" native-type="submit" class="btn">确认</van-button>
        </div>
    </van-form>
    <div class="footer">
      <van-button round block class="btnClo" @click="toInfo">取消</van-button>
    </div>
  </div>
  </div>
</template>

<script>
import api from '@/apis'
import moment from 'moment'
export default {
  name: "addWork",
  data(){
    return {
      baseinfo:{
        empno: "", //工号
        begindate: "", //开始时间
        enddate: "", //结束时间
        workcity: "", //工作城市
        organization: "", //公司名称
        position: "", //岗位名称
        duty: "",
      }
    }
  },
  methods: {
    // 提交表单
    onSubmit(){
      let obj = {
        ...this.baseinfo,
        begindate:moment(this.baseinfo.begindate).format('YYYY-MM-DD'),
        table:'euBgworkexpList',
        saveType:'1',
        empid:this.$store.state.userInfo.empID,
        empno:this.$store.state.userInfo.empNo
      }
      api.setSaveEmpInfo(obj).then(()=>{
        this.$toast('添加成功');
        this.$router.push({
        path:'/mobile/info',
        query:{
          type:'add'
        }
        })
      })
    },
    //跳转
    toInfo(){
      this.$router.push({
        path:'/mobile/info',
        query:{
          type:'no'
        }
      })
    },
    //开始时间和结束时间判断
    setStateTime(){
      if(this.baseinfo.begindate>this.baseinfo.enddate && this.baseinfo.enddate){
        this.$toast('开始时间不能大于开始时间')
        this.baseinfo.begindate = ''
      }
    },
    //结束时间和开始时间判断
    setEndTime(){
      if(this.baseinfo.enddate<this.baseinfo.begindate){
        this.$toast('开始时间不能小于开始时间')
        this.baseinfo.enddate = ''
      }
    }
  },
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .addWork {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .addWork {
    width: 276px * $zoom;
  }
}
.box{
  display: flex;
  justify-content: center;
}
.addWork {
  font-size: 16px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
}
.fromBox{
    height: 90vh;
}
.btnBox{
    width: 50%;
    position: absolute;
    bottom: 20px * $zoom;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px * $zoom 20px * $zoom;
    margin-left: 50%;
}
.btn {
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
}
.footer{
  width: 50%;
  position: absolute;
  bottom: 20px * $zoom;
  display: flex;
  justify-content: flex-end;
  padding: 10px * $zoom 20px * $zoom;
}
.btnClo{
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
  border: none;
}
</style>
